<template lang="pug">
    .re-contact-atopic-dermatitis
        .app-choice-group(v-if="!hasDermatitis")
            .app-choice-group__label Указать новое основное заболевание?
            .app-userhoice-group__listusers
                app-choice(
                    v-model="addDermatitis"
                    type="radio"
                    radio-value="0"
                    label="Нет"
                )
                app-choice(
                    v-model="addDermatitis"
                    type="radio"
                    radio-value="1"
                    label="Да"
                )

        .re-contact-atopic-dermatitis__wrapper(:class="{disabled: !hasDermatitis && addDermatitis==='0'}")
            h4 Диагноз
            diagnoses-block(
                v-model="diagnoses"
                ref="diagnoses"
                is-re-contact
            )

            h4 Таргентная терапия
            target-therapy-block(
                v-model="targetTherapy"
                ref="targetTherapy"
                is-re-contact
            )

            h4 Базисная терапия
            therapy-block(
                v-model="basicTherapy"
                ref="basicTherapy"
                is-re-contact
            )

            h4 Обострения с последнего визита
            exacerbations-block(
                v-model="exacerbations"
                ref="exacerbations"
                with-cause
                is-re-contact
            )

            h4 Нежелательные эффекты
            unwanted-effects-block(
                v-model="unwantedEffects"
                ref="unwantedEffects"
                is-re-contact
            )

            h4 Опросники
            questionnaires-dermatitis(
                v-model="questionnairesDermatitis"
                ref="questionnairesDermatitis"
                is-re-contact
                :has-dermatitis="hasDermatitis"
            )

        .row.sticky-buttons-block
            app-button(
                large
                @click="saveAndContinue"
            ) Сохранить и продолжить заполнение
            app-button(
                :loading="saveLoading"
                large
                color="white"
                @click="saveAndClose"
            ) Сохранить и закончить заполнение
            app-link.app-link--red.app-link--left-margin(@click="close") Закрыть без сохранения
</template>

<script>
import TherapyBlock from '@/components/pages/patients/blocks/TherapyBlock';
import TargetTherapyBlock from '@/components/pages/patients/blocks/TargetTherapyBlock';
import DiagnosesBlock from '@/components/pages/patients/blocks/DiagnosesBlock';
import ExacerbationsBlock from '@/components/pages/patients/blocks/ExacerbationsBlock';
import UnwantedEffectsBlock from '@/components/pages/patients/blocks/UnwantedEffectsBlock';
import QuestionnairesDermatitis from '@/components/pages/patients/questionnaires/QuestionnairesDermatitis';
import saving from '@/mixins/saving';
import moment from 'moment';

export default {
    name: 're-contact-atopic-dermatitis',

    components: {
        TherapyBlock,
        TargetTherapyBlock,
        DiagnosesBlock,
        ExacerbationsBlock,
        UnwantedEffectsBlock,
        QuestionnairesDermatitis,
    },

    mixins: [saving],

    data: () => ({
        hasDermatitis: false,
        addDermatitis: '0',

        diagnoses: [],
        targetTherapy: [],
        basicTherapy: [],
        exacerbations: [],
        unwantedEffects: [],
        questionnairesDermatitis: [],
    }),

    mounted() {
        if (this.lastData && !this.hasDataFromLocalStorage) {
            const dermatitis = this.lastData.sicknesses.find(s => s.type === 'DERMATITIS');
            if (dermatitis) {
                this.hasDermatitis = true;

                this.diagnoses = this.$refs.diagnoses.getFormattedSavedFields(dermatitis.diagnoses);

                this.targetTherapy = this.$refs.targetTherapy.getFormattedSavedFields(dermatitis.target_therapies);

                this.basicTherapy = this.$refs.basicTherapy.getFormattedSavedFields(dermatitis.basis_therapies);

                this.exacerbations = this.$refs.exacerbations.getFormattedSavedFields(dermatitis.exacerbations);

                this.unwantedEffects = this.$refs.unwantedEffects.getFormattedSavedFields(dermatitis.unwanted_effects);

                this.questionnairesDermatitis = this.$refs.questionnairesDermatitis.getFormattedSavedFields(dermatitis.questionnaires);

                setTimeout(() => {
                    this.$refs.questionnairesDermatitis.addNewQuestionnaires(+moment());
                });
            }
        }
    },

    methods: {
        getFormFields() {
            if (!this.hasDermatitis && !+this.addDermatitis) {
                return {};
            }
            return {
                dermatitis: {
                    diagnoses: this.$refs.diagnoses.getFieldsForSave(),
                    target_therapies: this.$refs.targetTherapy.getFieldsForSave(),
                    basis_therapies: this.$refs.basicTherapy.getFieldsForSave(),
                    exacerbations: this.$refs.exacerbations.getFieldsForSave(),
                    unwanted_effects: this.$refs.unwantedEffects.getFieldsForSave(),
                    questionnaires: this.$refs.questionnairesDermatitis.getFieldsForSave(),
                },
            };
        },

        checkValid() {
            if (this.$refs.diagnoses.$v.$invalid
                || this.$refs.targetTherapy.$v.$invalid
                || this.$refs.basicTherapy.$v.$invalid
                || this.$refs.exacerbations.$v.$invalid
                || this.$refs.unwantedEffects.$v.$invalid
                || this.$refs.questionnairesDermatitis.$v.$invalid) {
                this.$refs.diagnoses.$v.$touch();
                this.$refs.targetTherapy.$v.$touch();
                this.$refs.basicTherapy.$v.$touch();
                this.$refs.exacerbations.$v.$touch();
                this.$refs.unwantedEffects.$v.$touch();
                this.$refs.questionnairesDermatitis.$v.$touch();
                return false;
            }
            return true;
        },
    },
};
</script>

<style lang="scss">
.re-contact-atopic-dermatitis {
    &__wrapper.disabled {
        opacity: 0.5;

        pointer-events: none;
    }

    @include mobile_or_P {
        max-width: 100vmin;
        margin: 0 auto;

        h4 {
            margin-bottom: 1rem;
        }
    }
}
</style>
